<template>
    <div>
        <div class="container">
            <Search
                    :data="queryData"
                    :field-list="fieldList"
                    @handleFilter="handleSearch"
                    @handleReset="handleClear"
                    :btnHidden="false"
                    :count="100"
            ></Search>
        </div>
        <div class="container">
            <TableList
                    :loading="loading"
                    :table-data="tableData"
                    :table-label="tableLabel" >
                <template v-slot:index="slot">
                    {{indexMethod(slot.scope.$index) }}
                </template>
                <template v-slot:operate="slot">
                    <div class="edit-box" @click="handleOrderEdit(slot.scope.row)">编辑</div>
                </template>
            </TableList>
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="query.pageNum"
                        :page-size="query.pageSize"
                        :total="query.pageTotal">
                </el-pagination>
            </div>
        </div>
        <LogistcsDialog :handleClose="handleClose" :dialogVisible="dialogVisible" v-if="dialogVisible"
                        :logistcsDialogData="logistcsDialogData"/>
    </div>
</template>

<script>
    import TableList from "@/modules/projectA/components/common/e-table-list";
    import LogistcsDialog from '../../components/order/logistcsDialog';
    import api from "../../api/order";
    import Search from "@/modules/projectA/components/common/e-search";

    export default {
        name: "logisticsManage",
        components: {TableList, LogistcsDialog, Search},
        props: {},
        data() {
            return {
                formData: {
                    orderNo: null,
                    purchaseCompany: null,
                    pageNum: 1,
                    pageSize: 10,
                },
                queryData: {
                    orderNo: null,
                    purchaseCompany: null,
                },
                fieldList: [
                    {label: "订单编号", type: "input", value: "orderNo"},
                    {label: "采购商名称", type: "input", value: "purchaseCompany"},
                ],
                logistcsDialogData: {},
                dialogVisible: false,
                query: {
                    orderNo: '',
                    purchaseCompany: '',
                    pageNum: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                loading: false,
                tableData: [],
                tableLabel: [
                     {label: '订单编号', param: 'orderNo', align: 'center', width: '200', fixed: 'left'},
                    {label: '采购商名称', param: 'purchaseCompany', align: 'center', fixed: 'left'},
                    {label: '发货单名称', param: 'orderShipmentName', align: 'center'},
                    {label: '操作', slot: 'operate', align: 'center',width:'180'},
                ],
            }
        },
        computed: {},
        methods: {
            handleSearch(val) {
                this.formData.orderNo = val.orderNo;
                this.formData.purchaseCompany = val.purchaseCompany;
                this.formData.pageNum = 1;
                this.getLogisticsManage();

            },
            indexMethod(index) {
                return (
                    (this.query.pageSize - 1) * this.query.pageNum + index + 1
                );
            },
            getLogisticsManage() {
                api.listSelfMentionShip(this.formData).then((res) => {
                    this.tableData = res.data.records;
                    this.query.pageTotal = res.data.total;
                })
            },

            handleClear() {
                this.formData = {
                    orderNo: null,
                    purchaseCompany: null,
                    pageNum: 1,
                    pageSize: 10,
                };
                this.getLogisticsManage();
            },
            handleOrderEdit(row) {
                this.dialogVisible = true;
                this.logistcsDialogData = {
                    orderShipmentId: row.orderShipmentId,
                    supplierId: row.supplierCompanyId
                };
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.query.pageNum = 1
                this.getLogisticsManage(this.query);
            },
            handleCurrentChange(val) {
                this.formData.pageNum = val;
                this.getLogisticsManage();
            },
            handleClose() {
                this.dialogVisible = false;
                this.getLogisticsManage();
            }
        },
        mounted() {
            this.getLogisticsManage();
        }

    }
</script>

<style scoped lang="scss">
    .pagination {
        display: flex;
        justify-content: flex-end;
    }
    .edit-box{
        color: #126EDF;
        cursor: pointer;
        &:hover{
            color: #0064c8;
        }
    }
</style>
